import {extendTheme} from "@mui/joy";

export function createCustomTheme(primaryColor) {
    return extendTheme({
        colorSchemes: {
            light: {
                palette: {
                    primary: {
                        50: primaryColor,
                        100: primaryColor,
                        200: primaryColor,
                        300: primaryColor,
                        400: primaryColor,
                        500: primaryColor,
                        600: primaryColor,
                        700: primaryColor,
                        800: primaryColor,
                        900: primaryColor,
                        solidColor: '#fff',
                        solidBg: primaryColor,
                        solidHoverBg: primaryColor,
                        plainColor: primaryColor,
                        plainHoverBg: '#ffece6',
                        outlinedBorder: primaryColor,
                        outlinedColor: primaryColor,
                        outlinedHoverBg: '#fff0e6',
                    },
                },
            },
        },
    });
}